

































import {
  defineComponent,
} from '@vue/composition-api';

const AnswerBubble = defineComponent({
  props: {
    avatar: { default: '' },
    message: { default: '' },
    badge: { default: '' },
    right: { default: false },
    time: { default: '00:00' },
    displayName: { default: true },
  },
  // setup(props) {},
});

export default AnswerBubble;
